<script setup lang="ts">
import { computed, ref, useI18n } from '#imports';
import { LanguageSelector } from 'r3ui-lib';
import { presentPageLoadError } from '~/utils/presentPageLoadError';

const { locale, locales, setLocale } = useI18n();
const isSwitching = ref(false);
const localeOptions = computed<Array<{ id: string; label: string }>>(() =>
  locales.value.map((item: { code: string; name?: string }) => ({
    id: item.code,
    label: item.name ?? item.code,
  }))
);

async function setLocaleHandler(value: string) {
  if (isSwitching.value || value === locale.value) return;
  if (!localeOptions.value.some((item: { id: string }) => item.id === value)) {
    throw new TypeError('Unsupported locale');
  }
  isSwitching.value = true;
  try {
    await setLocale(value as typeof locale.value);
  } catch (error) {
    presentPageLoadError(error);
  } finally {
    isSwitching.value = false;
  }
}
</script>

<template>
  <div
    :inert="isSwitching"
    :aria-busy="isSwitching"
  >
    <LanguageSelector
      :model-value="locale"
      :options="localeOptions"
      @update:model-value="setLocaleHandler"
    />
  </div>
</template>
